
import { Dispatch, SetStateAction } from 'react';
import { EDGE_TYPE_SPECIFIC_FIELDS } from '../utils/constants';
import { showToastMessage } from '../../../utils/commonFunctions';

interface EdgeFormProps {
    formData: any;
    setFormData: Dispatch<SetStateAction<{ [key: string]: any }>>;
    onChange?: (name: string, value: string) => void;
}

const EdgeForm = ({ formData, setFormData }: EdgeFormProps) => {

    const onChange = (name: string, value: string, max_length: number, type: string, info_msg: string) => {
        if ((type === 'text' && !isNaN(Number(value)) && value.length <= max_length) || (type !== 'text' && value.length <= max_length)) {
            setFormData((prev) => ({
                ...prev,
                typeSpecificParams: {
                    ...prev?.typeSpecificParams,
                    [name]: value
                }
            }));
        } else if (value.length > max_length) {
            showToastMessage('info', info_msg);
        }
    };

    return (
        <div className='w-100 d-flex flex-column gap-3'>
            <div className='w-100 d-flex gap-2 flex-wrap'>
                {EDGE_TYPE_SPECIFIC_FIELDS.map(({ label, name, type, required }, index) => {
                    const even_field = index % 2 !== 0;
                    const max_length = type === 'text' ? 8 : 26;
                    const info_msg = type === 'text' ? `Maximum ${max_length} digits allowed` : `Maximum ${max_length} characters allowed`;
                    return (
                        <div key={name} className={`d-flex flex-column ${even_field ? 'flex-1' : 'w-50'}`}>
                            <span className="cp-text">{label}</span>
                            <input
                                type="text"
                                name={name}
                                value={formData?.typeSpecificParams?.[name] || ''}
                                maxLength={max_length}
                                onChange={(event: any) => {
                                    onChange(name, event.target.value, max_length, type, info_msg);
                                }}
                                required={required}
                                className="form-control"
                                placeholder={`Enter ${name}`}
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    )
}

export default EdgeForm